import * as THREE from "three";
import { CSG } from "./csg/three-csg";
import { BufferGeometryUtils } from './BufferGeometryUtils';
import * as SkeletonUtils from 'three/examples/jsm/utils/SkeletonUtils'
import { isArray } from "lodash";

const intersectMeshes = async (mainMesh, secondMesh, mainMaterial = false) => {

    const cloneMainMesh = SkeletonUtils.clone(mainMesh);
    const cloneSecondMesh = SkeletonUtils.clone(secondMesh);


    const boxMaxCSG = CSG.fromMesh(cloneMainMesh);
    const boxMimCSG = CSG.fromMesh(cloneSecondMesh);

    const boxCSG = boxMaxCSG.intersect(boxMimCSG);

    const material = mainMaterial ? mainMesh.material : secondMesh.material

    const intersectMesh = CSG.toMesh(
        boxCSG,
        new THREE.Matrix4(),
        isArray(material) ? material[0] : material
    );
    intersectMesh.updateMatrix()

    return intersectMesh

}
export default intersectMeshes;
